import 'ol/ol.css';
import TileLayer from 'ol/layer/Tile.js';
import {fromLonLat} from 'ol/proj';
import OSM from 'ol/source/OSM.js';
import {Map, View, Feature} from 'ol';
import LineString from 'ol/geom/LineString.js';
import Circle from 'ol/geom/Circle.js';
import {Stroke, Style} from 'ol/style.js';
import sourceVector from 'ol/source/Vector.js';
import layerVector from 'ol/layer/Vector.js';
import Chart from 'chart.js/auto';
import zoomPlugin from 'chartjs-plugin-zoom/dist/chartjs-plugin-zoom.js';
Chart.register(zoomPlugin);
import annotationPlugin from 'chartjs-plugin-annotation/dist/chartjs-plugin-annotation.cjs';
Chart.register(annotationPlugin);
import graph_temp from './graph_temp.js'
import graph_pcpn from './graph_pcpn.js'
import graph_wind from './graph_wind.js'
import graph_flux_solaire from './graph_flux_solaire.js'
import graph_fumee from './graph_fumee.js'
import { fetchCapabilities } from 'wms-forecast-client/src/capabilities.js';
import { fetchFeatureInfo, filterTimes, formatWmsTime, runWithConcurrency } from 'wms-forecast-client/src/wms.js';
import { layerName, layerNames, styleForVariable, metaLayer } from 'wms-forecast-client/src/layers.js';
import { findGridAxes } from 'wms-forecast-client/src/gridAxes.js';

class Time_Series {
  constructor(){
    this.controller = null;
    this.id_model = document.getElementById('id_model');
    this.id_model_side = document.getElementById('id_model_side');
    this.id_var = document.getElementById('id_var');
    this.id_var_side = document.getElementById('id_var_side');
    this.id_start = document.getElementById('id_start');
    this.id_start_side = document.getElementById('id_start_side');
    this.id_end = document.getElementById('id_end');
    this.id_end_side = document.getElementById('id_end_side');
    this.id_delta = document.getElementById('id_delta');
    this.id_delta_side = document.getElementById('id_delta_side');
    this.id_message = document.getElementById('id_message');
    this.progress_bar = new Progress_bar(document.getElementById("id_progress"));
    this.request_completed=1;
    this.chart = null;
    this.grid_point_coor = null;
    this.grid_point_overlay = null;
    this.bbox=null;
    this.now=null;
    this.dateo=null;
    this.mod_lay=null;
    this.title=null;
    this.lat=this.lir_cook('series_lat');
    this.lon=this.lir_cook('series_lon');
    if(this.lat == "" || this.lon == ""){
      this.lat=45.5;
      this.lon=-73.68;
    }
    var zoom=this.lir_cook('series_zoom');
    if(zoom == ""){
      zoom=6;
    }
    this.map = new Map({
      target: 'id_map',
      layers: [
	new TileLayer({
	  source: new OSM()
	})
      ],
      view: new View({
	// Zoom over sourthern Quebec.
	center: fromLonLat([this.lon,this.lat]),
	zoom: zoom
      })
    });
    // Construct menues
    // Model menu list
    var models=["RDPS|RDPS","HRDPS|HRDPS","GDPS|GDPS","RAQDPS|RAQDPS"];
    // Variable mune lists
    this.variables=new Array();
    this.variables[0]=["wind|Vent", "temp|Temperature", "pcpntype|Type PCPN","SN|Neige","RN|pluie","FR|verglas","PE|grésil","PR|PCPN Totale","NT|Flux solaire, nuages"];
    this.variables[1]=[...this.variables[0]];
    this.variables[2]=[...this.variables[0]];
    this.variables[3]=["fumee|Fumée"];
    // End hour menu list
    var starts=["dateo|origine","now|maintenant"];
    var ends=["6|6","12|12","24|24","36|36","48|48","72|3 jours","168|7 jours"];
    var deltas=["1|1","3|3","6|6","12|12","24|24"];
    this.id_model.options.length=0;
    this.id_model_side.options.length=0;
    for (var i=0; i<models.length; i++){
      this.id_model.options[this.id_model.options.length]=new Option(models[i].split("|")[1], models[i].split("|")[0])
      this.id_model_side.options[this.id_model_side.options.length]=new Option(models[i].split("|")[1], models[i].split("|")[0])
    }
    this.id_var.options.length=0;
    this.id_var_side.options.length=0;
    for (var i=0; i< this.variables[0].length; i++){
      this.id_var.options[this.id_var.options.length]=new Option( this.variables[0][i].split("|")[1],  this.variables[0][i].split("|")[0])
      this.id_var_side.options[this.id_var_side.options.length]=new Option(this.variables[0][i].split("|")[1],  this.variables[0][i].split("|")[0])
    }
    this.id_start.options.length=0;
    this.id_start_side.options.length=0;
    for (var i=0; i<starts.length; i++){
      this.id_start.options[this.id_start.options.length]=new Option(starts[i].split("|")[1], starts[i].split("|")[0])
      this.id_start_side.options[this.id_start_side.options.length]=new Option(starts[i].split("|")[1], starts[i].split("|")[0])
    }
    this.id_end.options.length=0;
    this.id_end_side.options.length=0;
    for (var i=0; i<ends.length; i++){
      this.id_end.options[this.id_end.options.length]=new Option(ends[i].split("|")[1], ends[i].split("|")[0])
      this.id_end_side.options[this.id_end_side.options.length]=new Option(ends[i].split("|")[1], ends[i].split("|")[0])
    }
    this.id_delta.options.length=0;
    this.id_delta_side.options.length=0;
    for (i=0; i<deltas.length; i++){
      this.id_delta.options[this.id_delta.options.length]=new Option(deltas[i].split("|")[1]+"h", deltas[i].split("|")[0])
      this.id_delta_side.options[this.id_delta_side.options.length]=new Option(deltas[i].split("|")[1]+"h", deltas[i].split("|")[0])
    }
  }

  init_with_cookies(){
    var index=this.lir_cook('series_model_index');
    if(index != ""){
      this.id_model.selectedIndex=index;
      this.id_model_side.selectedIndex=index;
      this.update_var(index);
    }
    index=this.lir_cook('series_'+this.id_model.value+'_var_index');
    if(index != ""){
      this.id_var.selectedIndex=index;
      this.id_var_side.selectedIndex=index;
    }
    index=this.lir_cook('series_start_index');
    if(index != ""){
      this.id_start.selectedIndex=index;
      this.id_start_side.selectedIndex=index;
    }else{
      this.id_start.selectedIndex=1;
      this.id_start_side.selectedIndex=1;
    }
    index=this.lir_cook('series_end_index');
    if(index != ""){
      this.id_end.selectedIndex=index;
      this.id_end_side.selectedIndex=index;
    }
    index=this.lir_cook('series_delta_index');
    if(index != ""){
      this.id_delta.selectedIndex=index;
      this.id_delta_side.selectedIndex=index;
    }
  }

  update_var(selectedIndex){
    // Find if current variable is available for this model
    var index=-1;
    for (var i=0; i<this.variables[selectedIndex].length; i++){
      if (this.variables[selectedIndex][i].split("|")[0] == this.id_var.value){
	index=i;
      }
    }    
    if ( index == -1){
      // Current variable not available for this model, set choice to last user choise for this model
      index=this.lir_cook('series_'+this.id_model.value+'_var_index');
    }
    // Construct menue
    this.id_var.options.length=0;
    this.id_var_side.options.length=0;
    for (var i=0; i<this.variables[selectedIndex].length; i++){
      this.id_var.options[this.id_var.options.length]=new Option(this.variables[selectedIndex][i].split("|")[1], this.variables[selectedIndex][i].split("|")[0])
      this.id_var_side.options[this.id_var_side.options.length]=new Option(this.variables[selectedIndex][i].split("|")[1], this.variables[selectedIndex][i].split("|")[0])
    }
    this.id_var_side.selectedIndex=index;
    this.id_var.selectedIndex=index;
    this.cre_cook('series_'+this.id_model.value+'_var_index',index);
  }

  async get_data(lat,lon){
    this.id_message.innerHTML = "T&eacute;l&eacute;chargement des donn&eacute;es ..."
    // Effacer le maillage sur la carte si present
    if(this.grid_point_overlay){
      this.grid_point_overlay.clear();
    }
    // Abort any fetch requests in progress then create a fresh controller
    if(this.request_completed == 0 ){
      this.controller.abort();
    }
    this.request_completed=0;
    this.controller = new AbortController();
    const signal = this.controller.signal;
    this.progress_bar.update_progress_bar(0.01);

    // Récupérer les capabilities via wms-forecast-client
    const ttLayer = metaLayer(this.id_model.value);
    let caps;
    try {
      caps = await fetchCapabilities(ttLayer, signal);
    } catch(e) {
      console.error('Erreur GetCapabilities:', e);
      this.request_completed=1;
      return;
    }
    this.dateo = caps.dateo;
    const deltaHours = parseInt(this.id_delta.value);

    if( deltaHours < caps.deltaHours ){
      this.progress_bar.update_progress_bar(0.0);
      alert("L'interval doit être plus grand ou égal à "+String(caps.deltaHours)+'h, vous avez choisi '+String(deltaHours)+'h');
      this.request_completed=1;
      return;
    }

    this.continue_request(lat, lon, caps, signal);
  }

  async continue_request(lat, lon, caps, signal){
    if(this.id_var.value == 'temp'){
      var var_list=['TT','ES'];
    }else if (this.id_var.value == 'pcpntype' ){
      var var_list=['SN','RN','FR','PR'];
    }else if (this.id_var.value == 'PE'){
      // Note ice pellets = PR - (SN+RN+FR)
      var var_list=['SN','RN','FR','PR'];
    }else if (this.id_var.value == 'SN'){
      var var_list=['SN'];
    }else if (this.id_var.value == 'RN'){
      var var_list=['RN'];
    }else if (this.id_var.value == 'FR'){
      var var_list=['FR'];
    }else if (this.id_var.value == 'PR'){
      var var_list=['PR'];
    }else if (this.id_var.value == 'wind'){
      var var_list=['WSPD','WGE','WD'];
    }else if (this.id_var.value == 'NT'){
      var var_list=['NT','N4'];
    }else if (this.id_var.value == 'fumee'){
      var var_list=['EATM_PM2.5','SFC_PM2.5'];
    } else {
      alert('Internal error in class Time_Series, add variable '+this.id_var.value+' to set var_list');
      return;
    }
    const mod_lays = layerNames(this.id_model.value, var_list);
    console.log(mod_lays);

    // Déterminer le temps de départ
    if(this.id_start.value == "now"){
      this.now=new Date();
    }else if(this.id_start.value == "dateo"){
      this.now = new Date(this.dateo.valueOf())
    }else{
      alert("Internal error in series.js, add option "+this.id_start.value);
      return;
    }
    const deltaHours = parseInt(this.id_delta.value);
    // Arrondir this.now au multiple de deltaHours
    var remainder = this.now.getUTCHours() % deltaHours;
    if(remainder != 0){
      this.now.setUTCHours(this.now.getUTCHours() - remainder);
    }
    this.now.setUTCMinutes(0);
    this.now.setUTCSeconds(0);
    this.now.setUTCMilliseconds(0);

    // Filtrer les timestamps disponibles selon l'horizon et l'intervalle demandés
    const requestedHours = parseInt(this.id_end.value);
    const filteredTimes = filterTimes(caps.times, this.now, requestedHours, deltaHours);

    // Le flux solaire est une moyenne par intervalle : des intervalles mixtes
    // rendraient les barres incomparables entre elles.
    if (this.id_var.value === 'NT' && filteredTimes.length >= 2) {
      const intervals = filteredTimes.slice(1).map((t, i) => (t - filteredTimes[i]) / 3_600_000);
      const minH = Math.min(...intervals);
      const maxH = Math.max(...intervals);
      if (minH !== maxH) {
        alert(`Le graphique de flux solaire requiert un intervalle constant.\n` +
              `La série contient des intervalles de ${minH}h et ${maxH}h.\n` +
              `Choisissez un intervalle de ${maxH}h.`);
        this.request_completed = 1;
        return;
      }
    }

    const refTimeStr = formatWmsTime(this.dateo);
    const nhours = filteredTimes.length;
    const nij = nhours * mod_lays.length;
    console.table(nij);

    var ff = Array.from({ length: nhours }, () => new Array(mod_lays.length).fill(-999.));
    var ref_lat = null;

    let completed = 0;
    const tasks = [];
    for (let i = 0; i < nhours; i++) {
      for (let j = 0; j < mod_lays.length; j++) {
	tasks.push({ i, j });
      }
    }

    // Limiter la concurrence pour éviter de saturer GeoMet (HTTP 429) quand
    // nhours * mod_lays.length est grand.
    const CONCURRENCY = 10;
    await runWithConcurrency(tasks, async ({ i, j }) => {
      try {
	const { value, gridLon, gridLat } = await fetchFeatureInfo(
	  { layer: mod_lays[j], lat, lon, time: formatWmsTime(filteredTimes[i]), refTime: refTimeStr, style: styleForVariable(var_list[j], this.id_model.value) },
	  signal
	);
	ff[i][j] = value !== null ? value : (
	  (this.id_var.value == 'pcpntype' ||
	   this.id_var.value == 'PE' ||
	   this.id_var.value == 'SN' ||
	   this.id_var.value == 'RN' ||
	   this.id_var.value == 'FR') ? 0. : null
	);
	if(ref_lat === null && gridLon !== null){
	  ref_lat = gridLon;
	  this.grid_point_coor = [gridLon, gridLat];
	  if(this.grid_point_overlay){
	    this.grid_point_overlay.clear();
	  }
	  // Ne bloque pas la boucle de fetch : le maillage se dessine dès
	  // que le sondage des points voisins est terminé.
	  this.drawGridMesh(mod_lays[j], styleForVariable(var_list[j], this.id_model.value), formatWmsTime(filteredTimes[i]), refTimeStr, gridLon, gridLat, signal);
	}
	completed++;
	this.progress_bar.update_progress_bar(completed / nij);
      } catch (error) {
	// Quand il n'y a pas de précipitation, le WMS retourne une exception
	if(this.id_var.value == 'pcpntype' ||
	   this.id_var.value == 'PE' ||
	   this.id_var.value == 'SN' ||
	   this.id_var.value == 'RN' ||
	   this.id_var.value == 'FR'){
	  ff[i][j]=0.;
	}else{
	  ff[i][j]=null;
	}
	console.error('Error:', error);
      }
    }, CONCURRENCY);

    try {
      // La requête a été annulée car l'utilisateur a recliqué — ne pas tracer
      if(signal.aborted) return;
      if(this.id_var.value == 'temp'){
	graph_temp(this,filteredTimes,ff);
      }else if (this.id_var.value == 'pcpntype'){
	graph_pcpn(this,filteredTimes,ff,'ALL');
      }else if (this.id_var.value == 'PE'){
	graph_pcpn(this,filteredTimes,ff,'PE');
      }else if (this.id_var.value == 'SN'){
	graph_pcpn(this,filteredTimes,ff,'SN');
      }else if (this.id_var.value == 'RN'){
	graph_pcpn(this,filteredTimes,ff,'RN');
      }else if (this.id_var.value == 'FR'){
	graph_pcpn(this,filteredTimes,ff,'FR');
      }else if (this.id_var.value == 'PR'){
	graph_pcpn(this,filteredTimes,ff,'PR');
      }else if (this.id_var.value == 'wind'){
	graph_wind(this,filteredTimes,ff);
      }else if (this.id_var.value == 'NT'){
	graph_flux_solaire(this,filteredTimes,ff,parseInt(this.id_delta.value));
      }else if (this.id_var.value == 'fumee'){
	graph_fumee(this,filteredTimes,ff);
      } else {
	alert('Internal error in continue_request, add variable '+this.id_var.value);
	return;
      }
      this.progress_bar.update_progress_bar(1.);
      this.progress_bar.reset_progress_bar(0.);
      this.request_completed=1;
      this.id_message.innerHTML = "Donn&eacute;es charg&eacute;es : mod&egrave;le "+this.id_model.value+", date d'origine "+formatWmsTime(this.dateo)+", point de grille ("+ this.grid_point_coor+")"
    } catch (error) {
      console.error('Error:', error);
    }
  }

  // Trouve les deux vrais axes de la grille à (lon0, lat0) via
  // wms-forecast-client (sondage est/±45°/perpendiculaire, cf. gridAxes.js),
  // puis dessine le maillage 3x3 centré sur ce point.
  async drawGridMesh(layer, style, time, refTime, lon0, lat0, signal){
    try {
      const { axisU, axisV } = await findGridAxes({ layer, style, time, refTime, lon0, lat0 }, signal);
      if (signal.aborted) return;
      this.grid_point_overlay = this.gridMesh([lon0, lat0], axisU, axisV);
    } catch (error) {
      if (signal.aborted) return;
      console.error('Erreur lors du calcul du maillage de grille:', error);
    }
  }

  // Dessine un maillage 3x3 (lignes) centré sur point. axisU/axisV sont les
  // deux vecteurs [dLon, dLat] réels des axes de la grille trouvés par
  // sondage (pas nécessairement est/nord — voir drawGridMesh) — pas de
  // simples espacements lon/lat, pour rester correct même sur une grille
  // tournée (HRDPS) où ces vecteurs ne sont pas alignés avec les
  // méridiens/parallèles.
  gridMesh(point, axisU, axisV, color='red'){
    const [lon0, lat0] = point;
    var style = new Style({
      stroke: new Stroke({
	color: color,
	width: 2
      }),
    });
    // Point de la grille locale à (i, j) cellules du centre, en suivant les
    // vecteurs réels plutôt que des offsets lon/lat indépendants.
    const at = (i, j) => [
      lon0 + i * axisU[0] + j * axisV[0],
      lat0 + i * axisU[1] + j * axisV[1],
    ];
    const lines = [];
    for (let j = -1; j <= 1; j++) {
      lines.push([at(-1, j), at(1, j)]);
    }
    for (let i = -1; i <= 1; i++) {
      lines.push([at(i, -1), at(i, 1)]);
    }
    const features = lines.map(coords => {
      const feature = new Feature({
	geometry: new LineString(coords.map(c => fromLonLat(c)))
      });
      feature.setStyle(style);
      return feature;
    });

    // Cercle au point central, diamètre = une fraction de la plus petite
    // distance de grille (axisU/axisV) — le rayon est mesuré en coordonnées
    // projetées le long de l'axe le plus court pour rester correct à
    // l'échelle réelle peu importe la latitude.
    const DIAMETER_FRACTION = 0.7;
    const shortestAxis = Math.hypot(...axisU) <= Math.hypot(...axisV) ? axisU : axisV;
    const centerProj = fromLonLat([lon0, lat0]);
    const edgeProj = fromLonLat([
      lon0 + (DIAMETER_FRACTION / 2) * shortestAxis[0],
      lat0 + (DIAMETER_FRACTION / 2) * shortestAxis[1],
    ]);
    const radius = Math.hypot(edgeProj[0] - centerProj[0], edgeProj[1] - centerProj[1]);
    const circleFeature = new Feature({ geometry: new Circle(centerProj, radius) });
    circleFeature.setStyle(style);
    features.push(circleFeature);

    var sourceMesh = new sourceVector({
      projection: 'EPSG:4326',
      features: features
    });
    var vectorMesh = new layerVector({
      source: sourceMesh
    });
    this.map.addLayer(vectorMesh);
    return sourceMesh;
  }

  cre_cook(nom,contenu) {
    localStorage.setItem(nom,contenu);
  }
  lir_cook(nom) {
    var res = localStorage.getItem(nom);
    if(res){
      return res;
    }else{
      return "";
    }
  }
}

class Progress_bar {

  constructor(canvas){
    this.canvas=canvas;
  }

  update_progress_bar(percent){
    var ctx = this.canvas.getContext("2d");
    if(percent < .0001){
      ctx.fillStyle = "#FFF";
    } else {
      ctx.fillStyle = "#BBB";
    }
    ctx.fillRect(0, .4*this.canvas.height, this.canvas.width, .2*this.canvas.height);
    ctx.fillStyle = "#F00";
    ctx.fillRect(0, .4*this.canvas.height, percent*this.canvas.width, .2*this.canvas.height);
  }

  reset_progress_bar(){
    this.update_progress_bar(0);
    this.precent=0.
  }

}

export {Time_Series}
